import { useQuery } from "@tanstack/react-query";

export function useBitcoinBalance(address: string) {
  return useQuery({
    queryKey: [`https://mempool.space/api/address/${address}`],
    queryFn: async () => {
      const res = await fetch(`https://mempool.space/api/address/${address}`);
      if (!res.ok) {
        throw new Error('Failed to fetch balance');
      }
      const data = await res.json();
      // Return balance in satoshis
      return data.chain_stats.funded_txo_sum - data.chain_stats.spent_txo_sum;
    },
  });
}
